import { Component } from '@theme/component';

/**
 * Archive Drop Countdown Component
 * Handles countdown timers in archive popup dialogs
 */
export class ArchiveDropCountdown extends Component {
  constructor() {
    super();
    this.countdownInterval = null;
    this.dropDate = null;
  }

  connectedCallback() {
    super.connectedCallback();
    
    this.dropDate = this.dataset.dropDate;
    
    if (this.dropDate) {
      this.startCountdown();
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  startCountdown() {
    this.updateCountdown();
    
    this.countdownInterval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const dropTime = new Date(this.dropDate).getTime();
    const timeLeft = dropTime - now;

    if (timeLeft <= 0) {
      // Drop time reached - update display
      this.updateToActive();
      return;
    }

    // Update countdown display
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));

    const daysElement = this.querySelector('.countdown-days');
    const hoursElement = this.querySelector('.countdown-hours');
    const minutesElement = this.querySelector('.countdown-minutes');

    if (daysElement) daysElement.textContent = days.toString().padStart(2, '0');
    if (hoursElement) hoursElement.textContent = hours.toString().padStart(2, '0');
    if (minutesElement) minutesElement.textContent = minutes.toString().padStart(2, '0');
  }

  updateToActive() {
    // Update the countdown container to show active status
    const countdownContainer = this.closest('.project-popup__drop-countdown');
    if (countdownContainer) {
      countdownContainer.innerHTML = `
        <span class="drop-countdown-label">Status:</span>
        <div class="drop-countdown-timer">
          <span class="drop-status-value">Jetzt verfügbar</span>
        </div>
      `;
    }

    // Badge update - REMOVED

    // Stop the countdown
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }
}

if (!customElements.get('archive-drop-countdown')) {
  customElements.define('archive-drop-countdown', ArchiveDropCountdown);
}

// Initialize countdowns when popup opens
document.addEventListener('DOMContentLoaded', () => {
  // Watch for popup openings
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const countdownElements = node.querySelectorAll('.project-popup__drop-countdown');
          countdownElements.forEach((element) => {
            if (!element.hasAttribute('data-countdown-initialized')) {
              element.setAttribute('data-countdown-initialized', 'true');
              const countdown = document.createElement('archive-drop-countdown');
              countdown.dataset.dropDate = element.dataset.dropDate;
              element.appendChild(countdown);
            }
          });
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}); 